import React, { useEffect, useState } from "react";
import * as Fa from "react-icons/fa";
import { format, subDays } from "date-fns";
import { RadioButton } from "primereact/radiobutton";
import { toast } from "react-toastify";
import storage from "../../../Services/Storage";
import { MultiSelect } from "primereact/multiselect";
import { Calendar } from "primereact/calendar";
import Axios from "../../../api/Axios";
import { GetDateFormat } from "../../../Services/GlobalFunc/DateFormat";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const SalesPeriodicReportPDF = () => {
    const auth = storage.getLocal("user");
    const date = subDays(new Date(), 7);
    const [fromDate, setFromDate] = useState(date);
    const [toDate, setToDate] = useState(new Date());
    const [loadingExcel, setLoadingExcel] = useState(false);
    const [partynamesugg, setPartynamesugg] = useState([]);
    const [onchangepartyname, setOnchangepartyname] = useState([]);

    const typeWise = [
        { name: "Volume", key: "VOL" },
        { name: "Turnover", key: "VAL" },
    ];
    const [selectedtypeWise, setSelectedTypeWise] = useState(typeWise[0]);

    const handleExportPDF = async () => {
        const fDate = new Date(fromDate);
        const fromDateRange = format(fDate, "dd/MM/yyyy");
        const tDate = new Date(toDate);
        const toDateRange = format(tDate, "dd/MM/yyyy");
        let Invrpt = "SalesReport/salesPeriodicReportPDF?";

        if (onchangepartyname.length === 0) {
            toast.warning("Please select the customer name", {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 2000,
            });
            return;
        }

        let partyIds = onchangepartyname.map((item) => `${item.PARTY_CODE}`).join(",");

        try {
            setLoadingExcel(true);
            const InvrptApi = `${Invrpt}CompId=${auth.CompId}&fromDate=${fromDateRange}&toDate=${toDateRange}&type=${selectedtypeWise.key}&custIds=${partyIds}`;
            let dataresponse = await Axios.get(InvrptApi);

            if (dataresponse?.data?.length > 0) {
                const doc = new jsPDF("l", "mm", "a4"); // A4 landscape

                // 🔑 Make left margin smaller (5mm instead of 10mm)
                const leftMargin = 5;
                const rightMargin = 5;
                const pageWidth = doc.internal.pageSize.getWidth() - leftMargin - rightMargin;

                const colCount = Object.keys(dataresponse.data[0]).length;
                const colWidth = pageWidth / colCount;

                // Title
                doc.setFontSize(14);
                doc.text("Sales Periodic Report", leftMargin, 15);
                doc.setFontSize(10);
                doc.text(`From: ${fromDateRange}  To: ${toDateRange}`, leftMargin, 22);

                // Headers & rows
                const headers = Object.keys(dataresponse.data[0]);
                const rows = dataresponse.data.map((row) =>
                    headers.map((h) => row[h])
                );

                autoTable(doc, {
                    startY: 30,
                    margin: { left: leftMargin, right: rightMargin }, // ✅ use adjusted margins
                    head: [headers],
                    body: rows,
                    styles: {
                        fontSize: 7,
                        cellPadding: 2,
                        lineWidth: 0.1,
                        lineColor: [0, 0, 0],
                    },
                    headStyles: {
                        fillColor: [46, 125, 50],   // dark green background
                        textColor: [255, 255, 255],
                        fontSize: 7,
                        halign: "center",
                        valign: "middle",
                    },
                    bodyStyles: {
                        halign: "left",
                        valign: "top",
                    },
                    alternateRowStyles: {
                        fillColor: [245, 245, 245],
                    },
                    columnStyles: headers.reduce((acc, h, i) => {
                        if (
                            h.toLowerCase().includes("date") ||
                            h.toLowerCase().includes("volume") ||
                            h.toLowerCase().includes("id") ||
                            h.toLowerCase().includes("code")
                        ) {
                            acc[i] = { cellWidth: colWidth, halign: "center" };
                        } else {
                            acc[i] = { cellWidth: colWidth, halign: "left" };
                        }
                        return acc;
                    }, {}),
                    didDrawPage: (data) => {
                        const pageCount = doc.internal.getNumberOfPages();
                        doc.setFontSize(8);
                        doc.text(
                            `Page ${data.pageNumber} of ${pageCount}`,
                            doc.internal.pageSize.getWidth() - rightMargin - 30,
                            doc.internal.pageSize.getHeight() - 10
                        );
                    },
                });

                let formatname = `SalesPeriodicReport${GetDateFormat()}.pdf`;
                doc.save(formatname);
            } else {
                toast.warning("No data found between these dates", {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 2000,
                });
            }
            setLoadingExcel(false);
        } catch (error) {
            setLoadingExcel(false);
            console.error(error);
        }
    };

    useEffect(() => {
        const onPageLoad = async () => {
            let getparty = "SalesReport/salesPeriodicRptPartyName?";

            try {
                const responseApi = `${getparty}CompId=${auth.CompId}`;
                let dataresponse = await Axios.get(responseApi);
                setPartynamesugg(dataresponse.data);
            } catch (error) {
                console.log(error);
            }
        };
        onPageLoad();
    }, []);



    return (
        <div className="col-12 pt-0 pb-4">
            <div className="row">
                <div className="col-lg-4 col-md-4 col-sm-12">
                    <h3 className="py-2">Sales Periodic Report PDF</h3>
                </div>

                <div className="col-lg-8 col-md-8 col-sm-12">
                    <div className="float-end">
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={handleExportPDF}
                            disabled={loadingExcel}
                        >
                            {loadingExcel ? "Loading..." : "Report"}{" "}
                            {loadingExcel ? (
                                <span
                                    className="spinner-border spinner-border-sm"
                                    role="status"
                                    aria-hidden="true"
                                ></span>
                            ) : (
                                <Fa.FaDownload className="ms-2" />
                            )}
                        </button>
                    </div>
                </div>
            </div>
            <section className="sales-box">
                <form>
                    <div className="col-lg-12 col-md-12 col-sm-12 mb-3 pb-3 bottomBorder">
                        <label className="form-label d-block">Customer Type</label>
                        {typeWise.map((doc) => {
                            return (
                                <div key={doc.key} className="d-inline-flex">
                                    <RadioButton
                                        inputId={doc.key}
                                        name="doc"
                                        value={doc}
                                        onChange={(e) => setSelectedTypeWise(e.value)}
                                        checked={selectedtypeWise.key === doc.key}
                                    />
                                    <label htmlFor={doc.key} className="mx-2">
                                        {doc.name}
                                    </label>
                                </div>
                            );
                        })}
                    </div>
                    <div className="row">
                        <div className="col-lg-4 col-md-4 col-sm-12">
                            <label className="form-label">From Date</label>
                            <Calendar
                                onChange={(e) => setFromDate(e.value)}
                                showIcon
                                value={fromDate}
                                min="2010-01-01"
                                dateFormat="dd/mm/yy"
                                showMinMaxRange={true}
                            />
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-12">
                            <label className="form-label">To Date</label>
                            <Calendar
                                value={toDate}
                                onChange={(e) => setToDate(e.value)}
                                showIcon
                                dateFormat="dd/mm/yy"
                                showMinMaxRange={true}
                            />
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-12">
                            <label className="form-label">Customer Name</label>
                            <MultiSelect
                                value={onchangepartyname}
                                onChange={(e) => setOnchangepartyname(e.value)}
                                options={partynamesugg}
                                optionLabel='PARTY_NAME'
                                filter
                                placeholder="Select Customer"
                                display="chips"
                                showClear
                                resetFilterOnHide
                                closeIcon
                                itemTemplate={(option) => `${option.PARTY_CODE} - ${option.PARTY_NAME}`}
                                filterBy="PARTY_CODE,PARTY_NAME"
                            />
                        </div>
                    </div>
                </form>
            </section>
        </div>
    );
};
export default SalesPeriodicReportPDF;
